<div class="row" [formGroup]="formFindSubmarca">
  <div class="mb-3 col ">
    <label for="pageSize" class="form-label">Buscar Submarca</label>
    <input
      autocomplete="off"
      type="text"
      class="form-control"
      id="controlFindVendedor"
      placeholder="Informacion a buscar"
      formControlName="filter">
  </div>
  <div class="mb-3 col">
    <label for="selectOptionFindPortfolio" class="form-label">Opciones de Busqueda</label>
    <select id="selectOptionFindPortfolio" class="form-select" aria-label="Default select find option" formControlName="option">
      <option *ngFor="let column of columns" [value]="column.prop">{{column.name}}</option>
    </select>
  </div>
  <div class="mb-3 col">
    <label for="pageSize" class="form-label">Registros por página</label>
    <select id="pageSize" class="form-select" aria-label="Selector de cantidad de registros por pagina" [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}">
      <option *ngFor="let items of this.itemsCounts" [ngValue]="items">{{items}}</option>
    </select>
  </div>
</div>
<ng-container *ngIf="(this.dataSource$| async) as data">
  <ngx-datatable
    class="bootstrap"
    columnMode="force"
    trackByProp="id"
    rowHeight="auto"
    [columns]="columns"
    [rows]="(this.filteredRows$ | async)"
    [limit]="pageSize"
    [headerHeight]="50"
    [footerHeight]="50"
    [selectionType]="selectionType.checkbox"
    [selected]="selected"
    [selectAllRowsOnPage]="false"
    (select)="onSelect($event)">
  </ngx-datatable>
</ng-container>
<div class="mt-4 text-end">
  <button #btnCloseModal type="button" class="btn btn-danger me-2" (click)="back.emit()">
    <i class="fas fa-arrow-left"></i>
    <span>Regresar</span>
  </button>
  <button type="button" class="btn btn-success" [disabled]="!selected || selected.length === 0" (click)="create.emit(selected)">
    <span>Aceptar</span>
    <i class="fa fa-check"></i>
  </button>
</div>
